import React, { ReactNode } from "react";
import { Row, Col } from "antd";
import Title from "antd/lib/typography/Title";
import { Divider } from "../Divider/Divider";

type PageProps = {
  title: string;
};

export const Page: React.FC<PageProps> = ({ children, title }) => {
  return (
    <Row>
      <Col span={24}>
        <Row gutter={[0, 32]}>
          <Col xs={{ span: 24 }} lg={{ span: 16 }}>
            <Title level={2}>{title}</Title>
          </Col>
        </Row>
        {children}
      </Col>
    </Row>
  );
};
